import React, { createContext, useContext, useState, useEffect } from 'react';
import { api, getToken, apiFetch } from '../lib/api';

const PeopleContext = createContext({ people: [], colorMap: {}, team: [], reload: () => {} });

export function PeopleProvider({ children }) {
  const [people,   setPeople]   = useState([]);
  const [colorMap, setColorMap] = useState({});
  const [team,     setTeam]     = useState([]);

  const reload = () => {
    // Always load all colors (public endpoint)
    apiFetch('/artists/colors').then(map => {
      setColorMap(map);
    }).catch(() => {});

    // Load artists user has access to
    if (!getToken()) return;
    api.getArtists().then(d => {
      const artists = d.artists || [];
      setPeople(artists);
      setTeam(artists.map(a => a.name));
    }).catch(() => {});
  };

  useEffect(() => {
    reload();
    window.addEventListener('daysheets:login', reload);
    return () => window.removeEventListener('daysheets:login', reload);
  }, []);

  return (
    <PeopleContext.Provider value={{ people, colorMap, team, reload }}>
      {children}
    </PeopleContext.Provider>
  );
}

export function usePeople() {
  return useContext(PeopleContext);
}
